import { useAuth } from '../../auth/AuthContext';
import { EmptyState } from '../../components/ui';
import './curator-dashboard.css';

/** The static app of this image: `apps/web/public/curator-dashboard-app`, its data comes from `/api/curator-dashboard/*`. */
export const CURATOR_DASHBOARD_APP_URL = '/curator-dashboard-app/';

/** The same app in the curator's own mode: the api decides what the session opens (`/api/curator-dashboard/my`). */
export const MY_DASHBOARD_APP_URL = `${CURATOR_DASHBOARD_APP_URL}?my=1`;

/**
 * «Дашборд» of a curator (DATAANALYTICS-112, owner 03.11): the dashboard of the session's own account, nothing to pick.
 * The api decides what it holds — Академия ТОП whole for an account linked to its venues, and the venues whose curator in
 * FM's contacts has the login e-mail — and answers an empty list, never «all», when there is neither.
 */
export function MyDashboardPage() {
  return (
    <>
      <div className="page-header">
        <h1>Дашборд</h1>
        <p className="page-header__sub">Ученики, посещаемость и занятия ваших площадок. Данные обновляются каждые 30 минут.</p>
      </div>
      <iframe
        className="curator-dashboard__frame"
        src={MY_DASHBOARD_APP_URL}
        title="Дашборд"
        allow="fullscreen"
        data-testid="my-dashboard-frame"
      />
    </>
  );
}

/**
 * «Дашборд для кураторов» (DATAANALYTICS-112) — the check stage: an АДМИН picks one curator inside the frame and sees the
 * dashboard that curator will see; Владимир Костин signs it off before the curators get it.
 *
 * The frame hosts a self-contained app copied from Future Monitoring's operational dashboard, so its rules stay one
 * reviewable copy. The api is the boundary: it reads the FM snapshot and answers exactly ADMIN.
 *
 * Exactly ADMIN, on purpose: `minRole="ADMIN"` also opens for SUPPORT (it ranks above ADMIN, T.Z155).
 */
export function CuratorDashboardPage() {
  const { role } = useAuth();

  if (role !== 'ADMIN') {
    return (
      <div className="card">
        <EmptyState title="Раздел только для администраторов" hint="Пока дашборд проверяют перед выдачей кураторам." />
      </div>
    );
  }

  return (
    <>
      <div className="page-header">
        <h1>Дашборд для кураторов</h1>
        <p className="page-header__sub">Выберите куратора: дашборд откроется так, как его увидит этот куратор.</p>
      </div>
      <iframe
        className="curator-dashboard__frame"
        src={CURATOR_DASHBOARD_APP_URL}
        title="Дашборд для кураторов"
        allow="fullscreen"
        data-testid="curator-dashboard-frame"
      />
    </>
  );
}
